module.exports = __webpack_public_path__ + "static/media/user.bda8bce1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/user.svg
// module id = 966
// module chunks = 0